import { createApp } from "vue";
import { createPinia } from "pinia";
import { createAuth0 } from "@auth0/auth0-vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import * as Sentry from "@sentry/vue";

import App from "./App.vue";
import { router } from "./router";
import { env } from "./env";
import "./styles/main.css";

const app = createApp(App);

if (env.sentryDsn) {
  Sentry.init({
    app,
    dsn: env.sentryDsn,
    environment: env.environment,
    tracesSampleRate: 0.1,
  });
}

app.use(createPinia());
app.use(router);
app.use(VueQueryPlugin);
app.use(
  createAuth0({
    domain: env.auth0Domain,
    clientId: env.auth0ClientId,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: env.auth0Audience,
      scope: "openid profile email offline_access",
    },
    cacheLocation: "localstorage",
    useRefreshTokens: true,
    // If the refresh-token grant ever fails, fall back to silent iframe auth
    // before giving up (and only then does the 401 handler sign the user out).
    useRefreshTokensFallback: true,
  }),
);

app.mount("#app");
